<div class="theme-toolbar" [class.collapsed]="isCollapsed">
  <div class="toolbar-header" (click)="toggleCollapse()">
    <div class="toolbar-title">
      <span class="icon">🎨</span>
      <span>Theme Customizer</span>
    </div>
    <button class="collapse-btn" [class.collapsed]="isCollapsed" type="button">
      {{ isCollapsed ? '◀' : '▶' }}
    </button>
  </div>

  @if (!isCollapsed && themeConfig) {
    <!-- Tabs Navigation -->
    <div class="tabs-nav">
      <button
        class="tab-btn"
        [class.active]="activeTab === 'text'"
        (click)="setActiveTab('text')"
        type="button"
      >
        Text & Colors
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab === 'buttons'"
        (click)="setActiveTab('buttons')"
        type="button"
      >
        Buttons
      </button>
      <button
        class="tab-btn"
        [class.active]="activeTab === 'other'"
        (click)="setActiveTab('other')"
        type="button"
      >
        Other
      </button>
    </div>

    <div class="toolbar-content">
      <!-- Text & Colors Tab -->
      @if (activeTab === 'text') {
        <!-- Text Colors Section -->
        <div class="section">
          <h3 class="section-title">Colors</h3>
          <div class="controls-grid">
            <div class="control-group">
              <label for="color-primary">Primary</label>
              <div class="color-input-wrapper">
                <input
                  type="color"
                  id="color-primary"
                  [value]="themeConfig.colors.primary"
                  (input)="onColorChange('primary', $any($event.target).value)"
                  class="color-input"
                />
                <input
                  type="text"
                  [value]="themeConfig.colors.primary"
                  (input)="onColorChange('primary', $any($event.target).value)"
                  class="color-text-input"
                />
              </div>
            </div>

            <div class="control-group">
              <label for="color-secondary">Secondary</label>
              <div class="color-input-wrapper">
                <input
                  type="color"
                  id="color-secondary"
                  [value]="themeConfig.colors.secondary"
                  (input)="onColorChange('secondary', $any($event.target).value)"
                  class="color-input"
                />
                <input
                  type="text"
                  [value]="themeConfig.colors.secondary"
                  (input)="onColorChange('secondary', $any($event.target).value)"
                  class="color-text-input"
                />
              </div>
            </div>
          </div>

          <!-- Text Color Usage Example -->
          <div class="usage-example">
            <div class="example-text" [style.color]="themeConfig.colors.primary">
              Primary text color example
            </div>
            <div class="example-text" [style.color]="themeConfig.colors.secondary">
              Secondary text color example
            </div>
          </div>
        </div>

        <!-- Icon Color Section -->
        <div class="section">
          <h3 class="section-title">Icon Color</h3>
          <div class="controls-grid">
            <div class="control-group full-width">
              <label for="color-icon">Icon Color</label>
              <div class="color-input-wrapper">
                <input
                  type="color"
                  id="color-icon"
                  [value]="themeConfig.colors.iconColor"
                  (input)="onColorChange('iconColor', $any($event.target).value)"
                  class="color-input"
                />
                <input
                  type="text"
                  [value]="themeConfig.colors.iconColor"
                  (input)="onColorChange('iconColor', $any($event.target).value)"
                  class="color-text-input"
                />
              </div>
            </div>
          </div>
        </div>
      }

      <!-- Buttons Tab -->
      @if (activeTab === 'buttons') {
        <!-- Button Styles Section -->
        <div class="section">
          <h3 class="section-title">Button Styles</h3>
          @for (styleKey of buttonStyleKeys; track styleKey) {
            <div class="button-style-group">
              <h4 class="subsection-title">{{ getButtonStyleLabel(styleKey) }}</h4>
              <div class="controls-grid">
                <div class="control-group">
                  <label [for]="'btn-' + styleKey + '-color'">Text Color</label>
                  <div class="color-input-wrapper">
                    <input
                      type="color"
                      [id]="'btn-' + styleKey + '-color'"
                      [value]="themeConfig.buttonStyles[styleKey].color"
                      (input)="onButtonStyleChange(styleKey, 'color', $any($event.target).value)"
                      class="color-input"
                    />
                    <input
                      type="text"
                      [value]="themeConfig.buttonStyles[styleKey].color"
                      (input)="onButtonStyleChange(styleKey, 'color', $any($event.target).value)"
                      class="color-text-input"
                    />
                  </div>
                </div>

                <div class="control-group">
                  <label [for]="'btn-' + styleKey + '-bg'">Background</label>
                  <div class="color-input-wrapper">
                    <input
                      type="color"
                      [id]="'btn-' + styleKey + '-bg'"
                      [value]="themeConfig.buttonStyles[styleKey].bg"
                      (input)="onButtonStyleChange(styleKey, 'bg', $any($event.target).value)"
                      class="color-input"
                    />
                    <input
                      type="text"
                      [value]="themeConfig.buttonStyles[styleKey].bg"
                      (input)="onButtonStyleChange(styleKey, 'bg', $any($event.target).value)"
                      class="color-text-input"
                    />
                  </div>
                </div>

                <div class="control-group full-width">
                  <label [for]="'btn-' + styleKey + '-hover'">Hover Color</label>
                  <div class="color-input-wrapper">
                    <input
                      type="color"
                      [id]="'btn-' + styleKey + '-hover'"
                      [value]="themeConfig.buttonStyles[styleKey].hover"
                      (input)="onButtonStyleChange(styleKey, 'hover', $any($event.target).value)"
                      class="color-input"
                    />
                    <input
                      type="text"
                      [value]="themeConfig.buttonStyles[styleKey].hover"
                      (input)="onButtonStyleChange(styleKey, 'hover', $any($event.target).value)"
                      class="color-text-input"
                    />
                  </div>
                </div>
              </div>
              
              <!-- Button Style Example -->
              <div class="button-style-example">
                <app-button [style]="getButtonStyleEnum(styleKey)" [size]="ButtonSize.Medium">
                  {{ getButtonStyleLabel(styleKey) }} Example
                </app-button>
                <small class="example-hint">Hover to see hover state</small>
              </div>
            </div>
          }
        </div>

        <!-- Button Sizes (Border Radius) Section -->
        <div class="section">
          <h3 class="section-title">Button Border Radius</h3>
          <div class="controls-grid">
            @for (sizeKey of buttonSizeKeys; track sizeKey) {
              <div class="control-group">
                <label [for]="'btn-size-' + sizeKey">{{ getButtonSizeLabel(sizeKey) }}</label>
                <input
                  type="text"
                  [id]="'btn-size-' + sizeKey"
                  [value]="themeConfig.buttonSizes[sizeKey].borderRadius"
                  (input)="onButtonSizeChange(sizeKey, $any($event.target).value)"
                  class="text-input"
                  placeholder="e.g., 8px or 50%"
                />
              </div>
            }
          </div>
          
          <!-- Button Size Examples -->
          <div class="button-size-examples">
            <h4 class="subsection-title">Size Examples</h4>
            <div class="button-size-preview-grid">
              @for (sizeKey of buttonSizeKeys; track sizeKey) {
                <div class="button-size-preview">
                  <app-button [style]="ButtonStyle.Primary" [size]="getButtonSizeEnum(sizeKey)">
                    {{ getButtonSizeLabel(sizeKey) }}
                  </app-button>
                  <small class="size-hint">{{ themeConfig.buttonSizes[sizeKey].borderRadius }}</small>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- Button Preview Section -->
        <div class="section">
          <h3 class="section-title">Button Previews</h3>
          <div class="button-preview-grid">
            <div class="button-preview">
              <app-button [style]="ButtonStyle.Primary" [size]="ButtonSize.Small">
                Primary Small
              </app-button>
            </div>
            <div class="button-preview">
              <app-button [style]="ButtonStyle.Primary" [size]="ButtonSize.Medium">
                Primary Medium
              </app-button>
            </div>
            <div class="button-preview">
              <app-button [style]="ButtonStyle.Secondary" [size]="ButtonSize.Medium">
                Secondary
              </app-button>
            </div>
            <div class="button-preview">
              <app-button [style]="ButtonStyle.Danger" [size]="ButtonSize.Medium">
                Danger
              </app-button>
            </div>
          </div>
          <small class="preview-hint">Hover to see hover states</small>
        </div>
      }

      <!-- Other Components Tab -->
      @if (activeTab === 'other') {
        <!-- Amount Selector Section -->
        <div class="section">
          <h3 class="section-title">Amount Selector</h3>
          <div class="controls-grid">
            <div class="control-group">
              <label for="color-amount-selector-bg">Background</label>
              <div class="color-input-wrapper">
                <input
                  type="color"
                  id="color-amount-selector-bg"
                  [value]="themeConfig.colors.amountSelectorBg"
                  (input)="onColorChange('amountSelectorBg', $any($event.target).value)"
                  class="color-input"
                />
                <input
                  type="text"
                  [value]="themeConfig.colors.amountSelectorBg"
                  (input)="onColorChange('amountSelectorBg', $any($event.target).value)"
                  class="color-text-input"
                />
              </div>
            </div>

            <div class="control-group">
              <label for="color-amount-selector-text">Text Color</label>
              <div class="color-input-wrapper">
                <input
                  type="color"
                  id="color-amount-selector-text"
                  [value]="themeConfig.colors.amountSelectorText"
                  (input)="onColorChange('amountSelectorText', $any($event.target).value)"
                  class="color-input"
                />
                <input
                  type="text"
                  [value]="themeConfig.colors.amountSelectorText"
                  (input)="onColorChange('amountSelectorText', $any($event.target).value)"
                  class="color-text-input"
                />
              </div>
            </div>
          </div>

          <!-- Amount Selector Preview -->
          <div class="amount-selector-preview">
            <app-amount-selector
              [options]="[10, 20, 30]"
              [isCustomAmountVisible]="true"
            ></app-amount-selector>
          </div>
        </div>
      }


    </div>

    <!-- Action Buttons - Sticky Footer -->
    <div class="section actions">
      <button class="btn btn-secondary" (click)="resetToDefault()" type="button">
        🔄 Reset to JSON
      </button>
      <button class="btn btn-accent" (click)="pasteJsonConfig()" type="button">
        📄 Paste JSON Config from Clipboard
      </button>
      <button class="btn btn-primary" (click)="copyJsonConfig()" type="button">
        📋 Copy JSON Config
      </button>

      <!-- Success/Error Message -->
      @if (showCopiedMessage) {
        <div class="message" [class.success]="messageType === 'success'" [class.error]="messageType === 'error'">
          @if (messageType === 'success') {
            ✓ {{ messageText }}
          } @else {
            ✗ {{ messageText }}
          }
        </div>
      }
    </div>
  }
</div>
